import { css } from '@emotion/css';
import { THEME_COLOR } from '@/archive/styles/colors';

export const flexBetween = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const flexCenter = (gap?: number) => css`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${gap ?? 0}px;
`;

export const flexStart = (gap?: number) => css`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${gap ?? 0}px;
`;

export const flexVertical = (gap?: number) => css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${gap ?? 0}px;
`;

export const margin = (value: string) => css`
  margin: ${value};
`;

export const padding = (value: string) => css`
  padding: ${value};
`;

export const sectionUnderline = css`
  border-bottom: 2px solid #676969;
`;

export const pageTitleStyle = css`
  color: black;
  font-size: 32px;
  padding-bottom: 14px;
`;

export const noticeText = css`
  font-size: 14px;
  color: #f03c78;
`;

export const warnText = css`
  display: inline-block;
  color: ${THEME_COLOR.WARNING_01};
  font-size: 12px;
  line-height: 18px;
`;

export const defaultFormTable = css`
  padding: 20px 0;
  th {
    vertical-align: top;
    width: 104px;
    padding: 10px 0 0 16px;
    text-align: left;
    color: #212121;
    font-size: 14px;
  }

  td {
    padding: 0 0 20px 16px;

    > div {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    > *:not(:last-child) {
      margin-bottom: 8px;
    }
  }

  em {
    display: inline-block;
    width: 5px;
    height: 5px;
    margin: -1px 0 0 1px;
    vertical-align: top;
    background: url(/bu_important.png) no-repeat;
    text-indent: -9999px;
  }
`;

export const defaultSectionStyle = css`
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 50px;
`;

export const cardStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;
  height: 180px;
  width: 250px;
  border: 1px solid #dfdfdf;
  border-radius: 10px;
  padding: 35px 35px 10px 35px;
  text-align: center;
`;

export const fontSize = (size: number) => css`
  font-size: ${size}px;
`;

export const defaultImageContainerWrapper = (bgColor: string) => css`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${bgColor};
  width: 100%;
`;

export const defaultImageContainer = css`
  width: 100%;
  min-width: 1440px;
  max-width: 1920px;
  display: flex;
  align-items: center;
  justify-content: center;

  > img {
    width: 100%;
    height: auto;
  }
`;

export const dateStyle = css`
  padding-left: 23px;
  vertical-align: middle;
  margin-top: 8px;
  background: url(https://s.wink.co.kr/pc/images/icon_calendar.png) no-repeat;
  color: ${THEME_COLOR.LIGHT_GREY_02};
  font-size: 14px;
  line-height: 18px;
`;

export const writerStyle = css`
  padding-left: 23px;
  background: url(https://s.wink.co.kr/pc/images/icon_user.png) no-repeat;
  color: #999;
  font-size: 14px;
`;

export const timesAgoStyle = css`
  margin: 0 4px;
  padding-left: 10px;
  background: url(https://s.wink.co.kr/pc/images/bu_dot2.png) 0 5px no-repeat;
  color: #999;
  font-size: 14px;
`;

export const colorStyle = (color: string) => css`
  color: ${color};
`;

export const commonImageContainer = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const nextButtonContainerStyle = css`
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50px 0;

  img {
    width: 450px;
  }
`;

export const defaultFieldsetStyle = css`
  display: grid;
  grid-template-columns: 110px 1fr;
  align-items: start;

  > label {
    position: relative;
    display: inline-flex;
    align-items: center;
    height: 40px;
    color: ${THEME_COLOR.BLACK_05};
    font-size: 14px;

    em {
      display: inline-block;
      width: 5px;
      height: 5px;
      transform: translate(2px, -7px);
      vertical-align: top;
      background: url(https://s.wink.co.kr/pc/images/bu_important.png) no-repeat;
      text-indent: -9999px;
    }
  }

  input ~ p {
    display: none;
  }

  input:focus:invalid ~ p {
    display: block;
    margin: 8px 0 0 4px;
    padding-left: 23px;
    background: url(https://s.wink.co.kr/pc/images/icon_notice3.png) 0 3px
      no-repeat;
    color: #e83030;
    font-size: 14px;
  }
`;

export const afterDescriptionStyle = (margin?: string) => css`
  display: block;
  margin: ${margin ?? '8px 0 0'};
  color: #999;
  font-size: 14px;
`;

export const TitleStyle = css`
  margin-bottom: 14px;
  color: black;
  font-size: 32px;
`;

export const modalContentStyle = (props?: { width?: number }) => css`
  width: ${props?.width ?? 480}px;
  padding: 50px 50px 40px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  text-align: center;
`;
